import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import batchCreateReducer from './batchCreate';
import cryoboxCreateReducer from './cryoboxCreate';
import batchListReducer from './batchList';
import batchReducer from './batch';
import cryoboxReducer from './cryobox';
import cryoboxesReducer from './cryoboxList';
import freezerListReducer from './freezerList';
import rgcLinkingReducer from './rgcLinking';
import createStageShipmentReducer from './stagedShipmentCreate';
import listAliquotLocationReducer from './aliquotLocationList';
import stagedShipmentMetaReducer from './stagedShipmentMetaList';
import stagedShipmentListReducer from './stagedShipmentList';
import rankedCryoboxListReducer from './stagedShipmentCryoboxRanked';
import addCryoboxToStagingReducer from './stagedShipmentCryoboxAdd';
import removeCryoboxFromStagingReducer from './stagedShipmentCryoboxDelete';
import resetStagedShipmentReducer from './stagedShipmentReset';
import shipmentPickListReducer from './stagedShipmentPickList';
import moveStagedAliquotReducer from './stagedShipmentMoveAliquot';
import manifestStagedShipmentReducer from './stagedShipmentManifest';
import listShipmentsReducer from './shipmentList';
import getShipmentReducer from './shipmentGet';
import getShipmentManifestReducer from './shipmentGetManifest';
import finaliseShipmentReducer from './shipmentFinalise';
import shipmentConfirmQCReducer from './shipmentConfirmQC';

const store = configureStore({
  reducer: {
    batchCreate: batchCreateReducer,
    batchList: batchListReducer,
    batch: batchReducer,
    cryoboxCreate: cryoboxCreateReducer,
    cryoboxList: cryoboxesReducer,
    cryobox: cryoboxReducer,
    freezerList: freezerListReducer,
    rgcLinking: rgcLinkingReducer,
    createStagedShipment: createStageShipmentReducer,
    aliquotLocations: listAliquotLocationReducer,
    stagedShipmentMeta: stagedShipmentMetaReducer,
    stagedShipmentList: stagedShipmentListReducer,
    rankedCryoboxList: rankedCryoboxListReducer,
    addCryoboxToStaging: addCryoboxToStagingReducer,
    removeCryoboxFromStaging: removeCryoboxFromStagingReducer,
    resetStagedShipment: resetStagedShipmentReducer,
    shipmentPickList: shipmentPickListReducer,
    moveStagedAliquot: moveStagedAliquotReducer,
    manifestStagedShipment: manifestStagedShipmentReducer,
    listShipments: listShipmentsReducer,
    getShipment: getShipmentReducer,
    getShipmentManifest: getShipmentManifestReducer,
    finaliseShipment: finaliseShipmentReducer,
    shipmentConfirmQC: shipmentConfirmQCReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
